function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M148.792 91.04s-2.446 7.63-8.48 10.348c-6.033 2.718-13.369-.506-13.369-.506s2.241-8.086 8.274-10.804c6.034-2.718 13.575.961 13.575.961zm-42.417 9.311s-7.272 3.365-13.357.764c-6.085-2.6-8.679-10.182-8.679-10.182s7.469-3.825 13.554-1.224c6.085 2.6 8.482 10.642 8.482 10.642z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M87.014 81.472a.837.837 0 01.124-.149c1.66-1.548 6.34-2.323 8.696-2.323 2.247 0 5.901 0 7.656 1.323.216.163.347.41.413.672a2.242 2.242 0 01-2.175 2.786H88.25c-1.186 0-1.894-1.322-1.236-2.309zm56.429.184c-1.593-1.86-7.171-2.656-9.562-2.656-2.312 0-6.113 0-7.082 1.44a1.024 1.024 0 00-.133.326 2.426 2.426 0 002.354 3.015h13.361c1.094 0 1.719-1.25 1.062-2.125zM89.871 93.545a5.578 5.578 0 1111.09 1.21 5.578 5.578 0 01-11.09-1.21zm40.286 1.99a5.579 5.579 0 1111.072-1.38 5.579 5.579 0 01-11.072 1.38z",
  fill: "#212121"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M127.321 120.682c1.333-.282 2.617.746 2.083 2-1.551 3.644-6.01 7.318-11.949 7.318-6.016 0-11.109-3.769-12.831-7.459-.56-1.2.645-2.211 1.944-1.952 2.446.487 6.411 1.099 10.887 1.099a48.29 48.29 0 009.866-1.006z",
  fill: "#5F3460"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.845 88.665c6.832 1.833 9.249 8.656 9.986 11.676l-1.79.437c-.721-2.95-2.916-8.788-8.673-10.332-5.216-1.399-8.76.118-11.229 1.175-.315.135-.614.263-.895.376l-.686-1.711c.257-.103.54-.225.845-.357 2.49-1.072 6.583-2.835 12.442-1.264zm38.867.205c-6.795 1.964-9.079 8.833-9.758 11.867l1.799.402c.663-2.962 2.744-8.843 8.471-10.498 5.188-1.5 8.76-.052 11.249.957.318.13.619.251.903.359l.653-1.724c-.26-.099-.544-.215-.853-.34-2.509-1.024-6.636-2.708-12.464-1.023z",
  fill: "#212121"
});

function SvgFace1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/media/face-1.6252a283.svg";
export { SvgFace1 as ReactComponent };